// extracted by mini-css-extract-plugin
module.exports = {"table":"table--3HwGZ","searchBox":"searchBox--AFbla"};